import { Box, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import CustomTypography from '../Typography'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

const LabelContainer = ({
  showPassword,
  setShowPassword,
  setCustomizeType,
  isPasswordField,
  children,
  type,
  label,
  minHeight,
  required,
  info
}) => {
  const labelContent = label
    ? (
      <>
        <CustomTypography
          sx={{
            color: (theme) => theme.colors.gunmetalBlue,
            fontSize: type === 'filter' || type === 'dateFilter' ? '12px' : undefined,
            fontWeight: type === 'filter' || type === 'dateFilter' ? 600 : undefined
          }}
          variant='subtitle1'
          value={`${label}`}
        />
        {required && (
          <CustomTypography
            sx={{ color: (theme) => theme.colors.red }}
            variant='subtitle1'
            value='*'
          />
        )}
        {info && (
          <Tooltip title={info} arrow placement='top'>
            <HelpOutlineIcon
              sx={{
                ml: 0.5,
                fontSize: 14,
                color: (theme) => theme.colors.gunmetalBlue,
                opacity: 0.7,
                cursor: 'help',
                verticalAlign: 'middle'
              }}
            />
          </Tooltip>
        )}
      </>
      )
    : null

  switch (type) {
    case 'none':
      return children
    case 'filter':
    case 'dateFilter':
      return (
        <div type={type}>
          <div>
            {labelContent}
          </div>
          {children}
        </div>
      )

    default:
      return (
        <Box>
          <Box height='24px' textAlign='start'>
            {labelContent}
            <span
              style={{
                float: 'right',
                position: 'relative',
                top: '1.813rem',
                zIndex: '1',
                left: '-3rem',
                height: '25px'
              }}
            >
              {isPasswordField &&
                (!showPassword
                  ? (
                    <VisibilityIcon
                      sx={{ fill: '#989898', width: '20px' }}
                      onClick={() => {
                        setShowPassword(true)
                        setCustomizeType('text')
                      }}
                    />
                    )
                  : (
                    <VisibilityOffIcon
                      sx={{ fill: '#989898', width: '20px' }}
                      onClick={() => {
                        setShowPassword(false)
                        setCustomizeType('password')
                      }}
                    />
                    ))}
            </span>
          </Box>
          {children}
        </Box>
      )
  }
}

export default LabelContainer

LabelContainer.defaultProps = {
  type: 'default',
  label: '',
  minHeight: '85px',
  info: ''
}

LabelContainer.propTypes = {
  type: PropTypes.oneOf(['filter', 'default', 'dateFilter', 'none']),
  label: PropTypes.string,
  children: PropTypes.element.isRequired,
  height: PropTypes.string,
  required: PropTypes.bool,
  info: PropTypes.string
}
